import React from "react";

import SimpleTab, { TItem } from "../../../component/ui/tabs/SimpleTab";
import Profile from "../misc/Profile";
import ChangePassword from "../misc/ChangePassword";
import ListAdminUser from "../misc/ListAdminUser";

const settingTabs: TItem[] = [
  { id: "profile", name: "My Profile" },
  { id: "password", name: "Change Password" },
  { id: "admins", name: "Admin Users" },
];

const Setting = () => {
  const [focused, setFocused] = React.useState<TItem>(settingTabs[0]);

  return (
    <div className="w-full h-full overflow-y-auto p-2">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Settings</h1>
        <p className="mt-1 text-sm text-gray-600">
          Manage your profile, password, and administrator accounts.
        </p>
      </div>
      <div className="w-fit">
        <SimpleTab
          className="font-semibold"
          items={settingTabs}
          focused={focused}
          onClick={setFocused}
        />
      </div>
      <div className="mt-4">
        {focused.id === "profile" ? (
          <Profile />
        ) : focused.id === "password" ? (
          <ChangePassword />
        ) : (
          <ListAdminUser />
        )}
      </div>
    </div>
  );
};

export default Setting;
